import { render, staticRenderFns } from "./TicketForm.vue?vue&type=template&id=628bec28&scoped=true"
import script from "./TicketForm.vue?vue&type=script&lang=js"
export * from "./TicketForm.vue?vue&type=script&lang=js"
import style0 from "./TicketForm.vue?vue&type=style&index=0&id=628bec28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628bec28",
  null
  
)

export default component.exports